export default __webpack_public_path__ + "static/media/Catch Ad 5-11.029e846a.pdf";